package della8.web.theme

object Della8Theme {
    val colors = Della8Colors
    val typography = Della8Typography
}